import * as React from 'react';
import Button from 'antd/lib/button';
import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons';
import { runwayColors } from '../styles/globalStyles';
import Popover from 'antd/lib/popover';
import { AppComponentProps } from '../../typescriptHelpers';
import { useDispatch } from 'react-redux';
import { tryArchiveBuildDistributionBuild, ARCHIVE_BUILD_DISTRIBUTION_BUILD } from '../../actions/buildDistribution';
import { ArchiveBuildDistributionBuildRequest } from '../../actions/entities';
import { useIsLoading } from '@/utils/hooks/helpers';

interface ArchiveBuildButtonProps extends AppComponentProps {
    bucketId: string;
    buildId: string;
}

const ArchiveBuildButton: React.FC<ArchiveBuildButtonProps> = (props: ArchiveBuildButtonProps) => {
    const { orgId, appId, bucketId, buildId } = props;

    const [popoverVisible, setPopoverVisible] = React.useState(false);

    const archiveBuildIsLoading = useIsLoading(ARCHIVE_BUILD_DISTRIBUTION_BUILD, buildId);

    const dispatch = useDispatch();

    const renderButton = () => {
        const button = (
            <Button icon={<DeleteOutlined />} onClick={archiveBuild} danger loading={archiveBuildIsLoading}>
                <span style={{ paddingLeft: 4 }}>{'Archive build'}</span>
            </Button>
        );

        return button;
    };

    const archiveBuild = () => {
        const request: ArchiveBuildDistributionBuildRequest = {
            appId,
            orgId,
            buildId,
            bucketId: bucketId,
        };
        dispatch(tryArchiveBuildDistributionBuild(request));
    };

    const ellipsisButton = (
        <Button icon={<EllipsisOutlined style={{ color: runwayColors.primary, fontSize: 24 }} />} type="link" />
    );

    return (
        <Popover
            content={renderButton()}
            open={popoverVisible}
            trigger="click"
            onOpenChange={(open) => setPopoverVisible(open)}
        >
            <>{ellipsisButton}</>
        </Popover>
    );
};

export default ArchiveBuildButton;
